import React, { useState } from 'react';
import './Creation.css';

const meubles = [
  {
    id: 1,
    titre: 'Meuble Suspendu',
    description: 'Meuble TV, Salon, Bar',
    resume: 'Création sur mesure alliant noyer massif et stratifié, conçue pour un salon contemporain.',
    details: [
      'Dimensions : 280 x 56 x 45 cm',
      'Bois : Tablette : noyer massif, Corpus : stratifier noir brillant, porte : stratifier mate colori vanille',
      'Finition : Vernis mate',
    ],
    photos: [
      '/images/meuble-1/meuble-1-1.png',
      '/images/meuble-1/meuble-1-2.png',
      '/images/meuble-1/meuble-1-3.png',
      '/images/meuble-1/meuble-1-4.png',
      '/images/meuble-1/meuble-1-5.png',
      '/images/meuble-1/meuble-1-6.png',
    ],
  },
  {
    id: 2,
    titre: 'Table Basse',
    description: 'Table Basse Pour Salon',
    resume: 'Pièce unique taillée dans un bloc d\'Afzelia massif de 65mm, aux formes épurées.',
    details: [
      'Dimensions : 149 x 67 x 45 cm',
      'Bois : Afzelia Massif (65 mm)',
      'Fabrication : Pièce Unique',
    ],
    photos: [
      '/images/meuble-2/meuble-2-1.png',
      '/images/meuble-2/meuble-2-2.png',
      '/images/meuble-2/meuble-2-3.png',
      '/images/meuble-2/meuble-2-4.png',
      '/images/meuble-2/meuble-2-5.png',
      '/images/meuble-2/meuble-2-6.png',
      '/images/meuble-2/meuble-2-7.png',
    ],
  },
  {
    id: 3,
    titre: 'Buffet',
    description: 'Buffet Design Contemporain',
    resume: 'Buffet au design contemporain mêlant stratifié gris/vert mate et chêne naturel.',
    details: [
      'Dimensions : 152 x 44 x 100 cm',
      'Bois : Stratifier Gris/Vert Mate, Chêne Naturel',
    ],
    photos: [
      '/images/meuble-3/meuble-3-1.png',
      '/images/meuble-3/meuble-3-2.png',
      '/images/meuble-3/meuble-3-3.png',
      '/images/meuble-3/meuble-3-4.png',
      '/images/meuble-3/meuble-3-5.png',
    ],
  },
];

function Creation() {
  const [indexes, setIndexes] = useState({});

  const photoPrecedente = (e, meubleId, longueur) => {
    e.stopPropagation();
    setIndexes((prev) => ({
      ...prev,
      [meubleId]: prev[meubleId] === undefined || prev[meubleId] === 0
        ? longueur - 1
        : prev[meubleId] - 1,
    }));
  };

  const photoSuivante = (e, meubleId, longueur) => {
    e.stopPropagation();
    setIndexes((prev) => ({
      ...prev,
      [meubleId]: prev[meubleId] === undefined
        ? 1
        : (prev[meubleId] + 1) % longueur,
    }));
  };

  return (
    <div className="creation-page">
      <h1>Nos Créations</h1>

      <div className="liste-meubles">
        {meubles.map((meuble) => {
          const index = indexes[meuble.id] || 0;
          return (
            <div key={meuble.id} className="ligne-meuble">

              {/* GAUCHE : Carousel photo */}
              <div className="carousel-gauche">
                <button onClick={(e) => photoPrecedente(e, meuble.id, meuble.photos.length)}>‹</button>
                <img
                  src={meuble.photos[index]}
                  alt={`${meuble.titre} - ${index + 1}`}
                />
                <button onClick={(e) => photoSuivante(e, meuble.id, meuble.photos.length)}>›</button>
                <p className="compteur">{index + 1} / {meuble.photos.length}</p>
              </div>

              {/* DROITE : Infos */}
              <div className="infos-droite">
                <h2>{meuble.titre}</h2>
                <p className="description">{meuble.description}</p>
                <p className="resume">{meuble.resume}</p>
                <ul className="details">
                  {meuble.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              </div>

            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Creation;